import { useEffect, useState } from 'react';

import { getAccessToken } from '@/config/auth/deviceToken';
import { decodeJwtPayload } from '@/config/auth/jwt';

/**
 * The signed-in Lucio (Clerk) account's email, read from the session token's
 * `primaryEmailAddress` custom claim. Distinct from the connected mailbox
 * email — the two can legitimately differ (e.g. a lucioai.com Lucio account
 * driving an outlook.com mailbox). Null while resolving or when the claim is
 * absent from the token template.
 */
export function useLucioAccountEmail(): string | null {
  const [email, setEmail] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    void getAccessToken().then((token) => {
      if (cancelled || !token) {
        return;
      }
      const claims = decodeJwtPayload<{ primaryEmailAddress?: string }>(token);
      setEmail(claims?.primaryEmailAddress ?? null);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return email;
}
